<template>
  <div class="home">
    <v-container mt-4>
      <v-layout>
        <v-flex>
          <Goldbuch></Goldbuch>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapState } from "vuex";
import Goldbuch from "@/components/Goldbuch";

export default {
  name: "Home",
  components: {
    Goldbuch
  },
  data() {
    return {
      loading: false,
      dialog: false,
      items: [],
      search: null,
      materialSuche: null,
      select: null,
      expand: false,
      isEditing: false,
      model: null,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      states: [],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        { text: "Vorname", value: "adresse.vorname" },
        { text: "Nachname", value: "adresse.nachname" },
        { text: "Material", value: "material.name" },
        { text: "Gussgewicht", value: "gussgewicht" }
      ],
      editedIndex: -1,
      editedItem: {
        datum: new Date().toISOString().substr(0, 10),
        adresse: {
          vorname: "",
          nachname: ""
        },
        material: {
          name: ""
        },
        gussgewicht: 0
      },
      defaultItem: {
        adresse: {
          vorname: "",
          nachname: ""
        },
        material: {
          name: ""
        },
        gussgewicht: 0
      }
    };
  },
  mounted() {
    this.$store.dispatch("loadVorgaenge");
    this.$store.dispatch("loadAdressen");
    this.$store.dispatch("loadMaterialien");
  },
  computed: {
    ...mapState(["vorgaenge", "adressen", "materialien"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    materialSuche(val) {
      this.items = this.materialien.filter(e => {
        return (
          (e.name || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1
        );
      });
      val && val !== this.select && this.items;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.$store.dispatch("addVorgang", this.editedItem);
      }
      this.close();
    },
    querySelections(v) {
      this.loading = true;

      this.items = this.adressen.filter(e => {
        return (
          ((e.vorname || "") + " " + (e.nachname || ""))
            .toLowerCase()
            .indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
table {
  width: 800px;
  margin: 0 auto;
  td {
    text-align: left;
    border: 1px solid #cfcfcf;
    padding: 2px 4px;
  }
}
</style>
